import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

function ElementoDespesaModal({ show, onClose, onSave, data }) {
  const [codigo, setCodigo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (show) {
      if (data) {
        setCodigo(data.codigo || '');
        setDescricao(data.descricao || '');
      } else {
        setCodigo('');
        setDescricao('');
      }
    }
  }, [data, show]);

  const handleSave = async () => {
    if (!codigo || !descricao) return;
    setSaving(true);
    try {
      const payload = { codigo, descricao };
      if (data) {
        await axios.put(`${API_BASE_URL.ELEMENTO_DESPESA}/${codigo}`, payload, { headers: { Authorization: `Bearer ${token}` } });
      } else {
        await axios.post(API_BASE_URL.ELEMENTO_DESPESA, payload, { headers: { Authorization: `Bearer ${token}` } });
      }
      if (onSave) onSave();
      if (onClose) onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header text-white" style={{ background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)', padding: '0.5rem 1rem' }}>
            <h6 className="modal-title mb-0">{data ? 'Editar Elemento de Despesa' : 'Novo Elemento de Despesa'}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={saving} aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label">Código</label>
              <input type="text" className="form-control" maxLength={6} value={codigo}
                onChange={e => setCodigo(e.target.value)} disabled={!!data} />
            </div>
            <div className="mb-2">
              <label className="form-label">Descrição</label>
              <textarea className="form-control" rows={4} value={descricao} onChange={e => setDescricao(e.target.value)} />
            </div>
          </div>
          <div className="modal-footer py-2">
            <button className="btn btn-secondary me-2" onClick={onClose} disabled={saving}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving || !codigo || !descricao}>
              {saving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ElementoDespesaModal;
